import React from "react";
import {Route, Routes, Navigate} from "react-router-dom";
import {locations} from "../../Utilities/Location";
import {DashboardContainer} from "../../Containers/Dashboard/";
import {LandingContainer} from "../../Containers/Landing/";
import {
    LibraryCatalogContainer,
    LibraryCatalogWhatsNewContainer,
    LibraryItemFormatContainer,
    LibraryItemContainer,
    LibraryPublisherContainer,
    LibraryQueueContainer,
    LibraryVendorContainer,
    AphCatalogItemContainer,
    AphQueueContainer,
    AphCatalogContainer,
    AphCatalogWhatsNewContainer,
    LoanLibraryCatalogContainer,
    LoanLibraryCatalogWhatsNewContainer,
    LoanLibraryQueueContainer,
    LoanLibraryHistoryContainer,
    LoanLibraryCatalogItemContainer,
    ManufacturerContainer,
    BraillerCatalogContainer,
    BraillerQueueContainer,
    BraillerHistoryContainer,
    BraillerCatalogItemContainer,
    BraillerRepairRequestContainer,
    BraillerLoanManagementContainer
} from "../../Containers/Library";
import {NotFoundContainer} from "../../Containers/NotFound/";
import {PageSetup} from "../../Containers/PageSetup/";
import {PasswordRequestContainer, PasswordUpdateContainer} from "../../Containers/Password";
import {ReportsContainer} from "../../Containers/Reports";
import {SignInContainer} from "../../Containers/SignIn/";
import {SignOutContainer} from "../../Containers/SignOut/";
import {StudentApprovalContainer, StudentRegistrationContainer} from "../../Containers/Student/";
import {UserApprovalContainer, UserProfileContainer, UserRegisterContainer} from "../../Containers/User/";
import {
    OrderManagementContainer,
    OrderProcessingContainer,
    OrderRequestContainer,
    ShippingLocationAddContainer
} from "../../Containers/Order/";
import {
    LoanManagementContainer,
    PackingListContainer,
    LoanHistoryContainer,
    AphLoanManagementContainer, 
    AphLoanHistoryContainer,
    LoanLibraryLoanManagementContainer
} from "../../Containers/Loan";
import {CheckInContainer} from "../../Containers/CheckIn";
import {DymoPrintLabelContainer} from "../../Containers/DymoPrinting/DymoPrintLabelContainer";
import {LoanLibraryPackingListContainer} from "../../Containers/PackingList";
import {BraillerPackingListContainer} from "../../Containers/PackingList/Braillers/BraillerPackingListContainer";

const SiteRoutes = () => {

    const Dashboard = <PageSetup component={DashboardContainer} path={locations.DASHBOARD.path}/>;
    const LandingPage = <PageSetup component={LandingContainer} path={locations.LANDING.path}/>;

    //LIBRARY
    const LibraryCatalogWhatsNewPage = <PageSetup component={LibraryCatalogWhatsNewContainer}
                                                  path={locations.LIBRARY_CATALOG.path} showCatalogLink/>;
    const LibraryCatalogPage = <PageSetup component={LibraryCatalogContainer} path={locations.LIBRARY_CATALOG.path}
    />;
    const LibraryFormatPage = <PageSetup component={LibraryItemFormatContainer} path={locations.LIBRARY_FORMAT.path}
                                         showCatalogLink/>;
    const LibraryItemPage = <PageSetup component={LibraryItemContainer} path={locations.LIBRARY_ITEM.path}
                                       showCatalogLink/>;
    const LibraryPublisherPage = <PageSetup component={LibraryPublisherContainer}
                                            path={locations.LIBRARY_PUBLISHER.path} showCatalogLink/>;
    const LibraryQueuePage = <PageSetup component={LibraryQueueContainer} path={locations.LIBRARY_QUEUE.path}
                                        showCatalogLink/>;
    const LibraryVendorPage = <PageSetup component={LibraryVendorContainer} path={locations.LIBRARY_VENDOR.path}
                                         showCatalogLink/>;
    const LibraryShippingLocationsPage = <PageSetup component={ShippingLocationAddContainer} path={locations.LIBRARY_SHIPPING_LOCATIONS.path}
                                                showCatalogLink/>;
    //LOAN
    const LoanProcessingPage = <PageSetup component={LoanManagementContainer} path={locations.LOAN_MANAGEMENT.path}/>;
    const LoanPackingListPage = <PageSetup component={PackingListContainer} path={locations.LOAN_PACKING_LIST.path}
                                           isPrint/>;
    const CheckInPage = <PageSetup component={CheckInContainer} path={locations.CHECK_IN.path}/>;
    const LoanHistoryPage = <PageSetup component={LoanHistoryContainer} path={locations.LOAN_HISTORY.path}
                                       showCatalogLink/>;


    //Order
    const OrderPackingListPage = <PageSetup component={PackingListContainer} path={locations.ORDER_PACKING_LIST.path}
                                            isPrint/>;
    const OrderRequestPage = <PageSetup component={OrderRequestContainer} path={locations.ORDER_REQUEST.path}
                                        showCatalogLink/>;
    const OrderViewPage = <PageSetup component={OrderRequestContainer} path={locations.ORDER_VIEW.path}
                                     showCatalogLink/>;
    const OrderManagementPage = <PageSetup component={OrderManagementContainer} path={locations.ORDER_MANAGEMENT.path}
    />;
    const OrderProcessingPage = <PageSetup component={OrderProcessingContainer} path={locations.ORDER_PROCESSING.path}
    />;
    const ShippingLocationAddPage = <PageSetup component={ShippingLocationAddContainer}
                                               path={locations.SHIPPING_LOCATION_ADD.path} showCatalogLink/>;
    const DymoPrintLabelPage = <PageSetup component={DymoPrintLabelContainer} path={locations.DYMO_PRINT_LABEL.path}
                                          showSignOutLink showCatalogLink/>;

    //Aph
    const AphCatalogItemPage = <PageSetup component={AphCatalogItemContainer} path={locations.APH_CATALOG_ITEM.path}
                                          showAphCatalogLink/>;
    const AphCatalogPage = <PageSetup component={AphCatalogContainer} path={locations.APH_CATALOG.path}/>;
    const AphQueuePage = <PageSetup component={AphQueueContainer} path={locations.APH_QUEUE.path}
                                    showAphCatalogLink/>;
    const AphWhatsNewPage = <PageSetup component={AphCatalogWhatsNewContainer} path={locations.APH_WHATS_NEW.path}
                                       showAphCatalogLink/>;
    //Aph Loan
    const AphLoanProcessingPage = <PageSetup component={AphLoanManagementContainer} path={locations.APH_LOAN_MANAGEMENT.path}/>;
    const AphLoanHistoryPage = <PageSetup component={AphLoanHistoryContainer} path={locations.APH_LOAN_HISTORY.path}/>;

    //Loan Library
    const LoanLibraryLoanManagementPage = <PageSetup component={LoanLibraryLoanManagementContainer} path={locations.LOAN_LIBRARY_LOAN_MANAGEMENT.path}/>;
    const LoanLibraryCatalogPage = <PageSetup component={LoanLibraryCatalogContainer} path={locations.LOAN_LIBRARY_CATALOG.path}
    />;
    const LoanLibraryCatalogItemPage = <PageSetup component={LoanLibraryCatalogItemContainer} path={locations.LOAN_LIBRARY_CATALOG_ITEM.path}
                                                  showLoanLibraryCatalogLink/>;
    const LoanLibraryQueuePage = <PageSetup component={LoanLibraryQueueContainer} path={locations.LOAN_LIBRARY_QUEUE.path}
                                            showLoanLibraryCatalogLink/>;
    const LoanLibraryHistoryPage = <PageSetup component={LoanLibraryHistoryContainer} path={locations.LOAN_LIBRARY_HISTORY.path}
                                              showLoanLibraryCatalogLink/>;
    const LoanLibraryManufacturerPage = <PageSetup component={ManufacturerContainer} path={locations.LOAN_LIBRARY_MANUFACTURER.path}
                                               showLoanLibraryCatalogLink/>;
    const LoanLibraryPackingListPage = <PageSetup component={LoanLibraryPackingListContainer} path={locations.LOAN_LIBRARY_PACKING_LIST.path}
                                           isPrint/>;
    const LoanLibraryWhatsNewPage = <PageSetup component={LoanLibraryCatalogWhatsNewContainer} path={locations.LOAN_LIBRARY_WHATS_NEW.path}
                                               showLoanLibraryCatalogLink/>;

    //Braillers
    const BraillerCatalogPage = <PageSetup component={BraillerCatalogContainer} path={locations.BRAILLER_CATALOG.path} />;
    const BraillerCatalogItemPage = <PageSetup component={BraillerCatalogItemContainer} path={locations.BRAILLER_CATALOG_ITEM.path}
      showBraillerCatalogLink/>;
    const BraillerQueuePage = <PageSetup component={BraillerQueueContainer} path={locations.BRAILLER_QUEUE.path}
      showBraillerCatalogLink/>;
    const BraillerHistoryPage = <PageSetup component={BraillerHistoryContainer} path={locations.BRAILLER_HISTORY.path}
         showBraillerCatalogLink/>;
    const BraillerLoanManagementPage = <PageSetup component={BraillerLoanManagementContainer} path={locations.BRAILLER_LOAN_MANAGEMENT.path} />;
    const BraillerRepairRequestPage = <PageSetup component={BraillerRepairRequestContainer} path={locations.BRAILLER_REPAIRS.path} />;
    const BraillerPackingListPage = <PageSetup component={BraillerPackingListContainer} path={locations.BRAILLER_PACKING_LIST.path}
                                           isPrint/>;

    //AUTHENTICATION
    const RegistrationPage = <PageSetup component={UserRegisterContainer} path={locations.REGISTER.path}/>;
    const SignInPage = <PageSetup component={SignInContainer} path={locations.SIGN_IN.path}/>;
    const SignOutPage = <PageSetup component={SignOutContainer} path={locations.SIGN_OUT.path}/>;
    const UpdatePasswordPage = <PageSetup component={PasswordUpdateContainer} path={locations.UPDATE_PASSWORD.path}/>;
    const ForgotPasswordPage = <PageSetup component={PasswordRequestContainer} path={locations.FORGOT_PASSWORD.path}/>;

    //USER
    const UserApprovalPage = <PageSetup component={UserApprovalContainer} path={locations.USER_MANAGEMENT.path}
    />;
    const UserProfilePage = <PageSetup component={UserProfileContainer}
                                       path={locations.USER_PROFILE.path}/>;
    //Student
    const StudentApprovalPage = <PageSetup component={StudentApprovalContainer} path={locations.STUDENT_MANAGEMENT.path}
    />;
    const StudentRegistrationPage = <PageSetup component={StudentRegistrationContainer}
                                               path={locations.REGISTER_STUDENT.path}/>;
    const EditStudentPage = <PageSetup component={StudentRegistrationContainer}
                                       path={locations.EDIT_STUDENT.path}/>;
    //REPORTS
    const ReportsPage = <PageSetup component={ReportsContainer} path={locations.REPORTS.path}/>;

    // *********************** LAST: NOT FOUND ***********************
    const NotFoundPage = <PageSetup component={NotFoundContainer} path={locations.NOT_FOUND.path}/>;

    return (
        <Routes>
            <Route path={locations.SIGN_IN.path} element={SignInPage}/>
            <Route path={locations.SIGN_OUT.path} element={SignOutPage}/>
            <Route path={locations.REGISTER.path} element={RegistrationPage}/>
            <Route path={locations.LANDING.path} element={LandingPage}/>

            {/* Loan Library */}
            <Route path={locations.LOAN_LIBRARY_CATALOG.path} element={LoanLibraryCatalogPage}/>
            <Route path={locations.LOAN_LIBRARY_CATALOG_ITEM.path} element={LoanLibraryCatalogItemPage}/>
            <Route path={locations.LOAN_LIBRARY_QUEUE.path} element={LoanLibraryQueuePage}/>
            <Route path={locations.LOAN_LIBRARY_HISTORY.path} element={LoanLibraryHistoryPage}/>
            <Route path={locations.LOAN_LIBRARY_MANUFACTURER.path} element={LoanLibraryManufacturerPage}/>
            <Route path={locations.LOAN_LIBRARY_WHATS_NEW.path} element={LoanLibraryWhatsNewPage}/>

            {/* Braillers */}
            <Route path={locations.BRAILLER_CATALOG.path} element={BraillerCatalogPage}/>
            <Route path={locations.BRAILLER_CATALOG_ITEM.path} element={BraillerCatalogItemPage}/>
            <Route path={locations.BRAILLER_QUEUE.path} element={BraillerQueuePage}/>
            <Route path={locations.BRAILLER_HISTORY.path} element={BraillerHistoryPage}/>
            <Route path={locations.BRAILLER_LOAN_MANAGEMENT.path} element={BraillerLoanManagementPage}/>
            <Route path={locations.BRAILLER_REPAIRS.path} element={BraillerRepairRequestPage}/>
            <Route path={locations.BRAILLER_PACKING_LIST.path} element={BraillerPackingListPage}/>

            {/* Library */}
            <Route path={locations.LIBRARY_WHATS_NEW.path} element={LibraryCatalogWhatsNewPage}/>
            <Route path={locations.LIBRARY_CATALOG.path} element={LibraryCatalogPage}/>
            <Route path={locations.LIBRARY_FORMAT.path} element={LibraryFormatPage}/>
            <Route path={locations.LIBRARY_ITEM.path} element={LibraryItemPage}/>
            <Route path={locations.LIBRARY_PUBLISHER.path} element={LibraryPublisherPage}/>
            <Route path={locations.LIBRARY_QUEUE.path} element={LibraryQueuePage}/>
            <Route path={locations.LIBRARY_VENDOR.path} element={LibraryVendorPage}/>
            <Route path={locations.LIBRARY_SHIPPING_LOCATIONS.path} element={LibraryShippingLocationsPage}/>
            <Route path={locations.LOAN_LIBRARY_PACKING_LIST.path} element={LoanLibraryPackingListPage}/>

            {/* Loan */}
            <Route path={locations.LOAN_MANAGEMENT.path} element={LoanProcessingPage}/>
            <Route path={locations.LOAN_PACKING_LIST.path} element={LoanPackingListPage}/>
            <Route path={locations.CHECK_IN.path} element={CheckInPage}/>
            <Route path={locations.LOAN_HISTORY.path} element={LoanHistoryPage}/>

            {/* Aph */}
            <Route path={locations.APH_CATALOG_ITEM.path} element={AphCatalogItemPage}/>
            <Route path={locations.APH_CATALOG.path} element={AphCatalogPage}/>
            <Route path={locations.APH_QUEUE.path} element={AphQueuePage}/>
            <Route path={locations.APH_WHATS_NEW.path} element={AphWhatsNewPage}/>

            {/* Aph Loan */}
            <Route path={locations.APH_LOAN_MANAGEMENT.path} element={AphLoanProcessingPage}/>
            <Route path={locations.APH_LOAN_HISTORY.path} element={AphLoanHistoryPage}/>

            {/* Loan Library Loan */}
            <Route path={locations.LOAN_LIBRARY_LOAN_MANAGEMENT.path} element={LoanLibraryLoanManagementPage}/>

            {/* Order */}
            <Route path={locations.ORDER_PACKING_LIST.path} element={OrderPackingListPage}/>
            <Route path={locations.ORDER_REQUEST.path} element={OrderRequestPage}/>
            <Route path={locations.ORDER_VIEW.path} element={OrderViewPage}/>
            <Route path={locations.ORDER_MANAGEMENT.path} element={OrderManagementPage}/>
            <Route path={locations.ORDER_PROCESSING.path} element={OrderProcessingPage}/>
            <Route path={locations.SHIPPING_LOCATION_ADD.path} element={ShippingLocationAddPage}/>
            <Route path={locations.DYMO_PRINT_LABEL.path} element={DymoPrintLabelPage}/>

            {/* Password */}
            <Route path={locations.FORGOT_PASSWORD.path} element={ForgotPasswordPage}/>
            <Route path={locations.UPDATE_PASSWORD.path} element={UpdatePasswordPage}/>
            <Route path={locations.DASHBOARD.path} element={Dashboard}/>

            {/* User */}
            <Route path={locations.USER_MANAGEMENT.path} element={UserApprovalPage}/>
            <Route path={locations.USER_PROFILE.path} element={UserProfilePage}/>

            {/* Student */}
            <Route path={locations.STUDENT_MANAGEMENT.path} element={StudentApprovalPage}/>
            <Route path={locations.REGISTER_STUDENT.path} element={StudentRegistrationPage}/>
            <Route path={locations.EDIT_STUDENT.path} element={EditStudentPage}/>

            {/* Reports */}
            <Route path={locations.REPORTS.path} element={ReportsPage}/>

            {/* Sad Routes */}
            <Route path="/" element={<Navigate to={locations.LANDING.path} replace/>}/>
            <Route path="/*" element={NotFoundPage}/>
            <Route path="*" element={<Navigate to={locations.LANDING.path} replace/>}/>
        </Routes>
    );
};

export {SiteRoutes};